export default {
  methods: {
    checkPermission(unique_name) {
      return this.$store.getters['permission/check'](unique_name);
    }
  }
};